/**
 * Which balls ask where they went (ADR-0022). The rule is one function so it can be tested
 * against every latch, and so the pad and the correction sheet cannot disagree about it.
 *
 * A direction describes a ball the *batter hit*, so nothing else asks:
 *
 * - A **wide** was not hit. A **bye** or **leg bye** was not hit by the bat either, and a
 *   no-ball with a bye is the same ball. None of them says anything about the batter.
 * - **Dots** have no direction to give.
 * - **A wicket** goes through the wicket sheet, which is the most delicate flow on the pad.
 *   Where a catch was taken is a follow-up, and until then a dismissal asks nothing extra.
 *
 * A **no-ball with runs off the bat** does ask: the batter hit it, and it is among the most
 * likely to go to the boundary. Everything else that scored off the bat asks, singles included:
 * a wheel of only the boundaries would say little about where a batter scores.
 */
import type { Latch } from "./entry.ts";
import type { WagonMode } from "./wagonPrefs.ts";

export function asksForDirection(latch: Latch, runs: number, mode: WagonMode): boolean {
  if (mode === "off") return false;
  if (latch.wicket) return false;
  if (latch.extra === "wide") return false;
  if (latch.bye !== null) return false;
  if (runs <= 0) return false;
  return true;
}
